import { Breadcrumb } from '../../../components/static/Breadcrumb';
import { ContactForm } from '../components/ContactForm';
import { ContactInfoCards } from '../components/ContactInfoCards';
import '../contact.css';

export function ContactPage() {
  return (
    <div className="ts-contact contact-info-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Breadcrumb
              items={[
                { label: 'الرئيسية', href: '/' },
                { label: 'اتصل بنا', active: true },
              ]}
            />
          </div>
        </div>

        <ContactInfoCards />

        <div className="row">
          <div className="col-lg-12">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}
